import {FormikProps} from 'formik';
import {IDirectDocsForm} from './formDetails';
import {ChangeEvent} from 'react';
import InputField from '../../../../../components/simpleInput';
import {ShowFormError} from '../../../../../utilities/helper/showFormError';

interface IProps {
  form: FormikProps<IDirectDocsForm>;
}

const FullNameInput = ({form}: IProps) => {
  return (
    <>
      <InputField
        name="ownerFullName"
        label="نام و نام خانوادگی مالک شماره"
        required
        value={form.values.ownerFullName || ''}
        placeholder="نام و نام خانوادگی مالک شماره را وارد کنید"
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          form?.setFieldValue('ownerFullName', e.target.value);
        }}
      />

      <ShowFormError field="ownerFullName" form={form} />
    </>
  );
};

export default FullNameInput;
